import React, { useState, useCallback, useEffect } from 'react'
import Caption from './caption'
import useStyles from './style1'
import { webMenuCopy, mobileMenu, Menu } from 'model/menuList'
import {
  Typography,
  Slide,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Button,
  InputAdornment,
  Autocomplete,
  TextField,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useNavigate, useSearchParams } from 'react-router-dom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import CustomRequestModal from 'pages/contact/customRequestModal'
import { setContactDetails } from 'redux/contactDetails/actions'
import { setMenuDrawer } from 'redux/menuDrawer/actions'
import homeApi from 'services/home'
import productApi from 'services/products'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import SearchIcon from '@mui/icons-material/Search'
import CircularProgress from '@mui/material/CircularProgress';


const Header = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const searchQuery = searchParams.get('search')
  const [drawer, setDrawer] = useState(false)
  const [menuList, setMenuList] = useState(Menu)
  const [openRequestModal, setOpenRequestModal] = useState(false)
  const [searchOptions, setSearchOptions] = useState([])
  const [search, setSearch] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const [searchLoading, setSearchLoading] = useState(false)

  const SEARCHPLACEHOLDER = "Search for jewels and more...?";
  const [searchPlaceHolder, setSearchPlaceHolder] = useState(SEARCHPLACEHOLDER)

  // Handle custom request modal
  const handleOpenRequestModal = () => {
    setOpenRequestModal(true)
  }
  const handleCloseRequestModal = () => {
    setOpenRequestModal(false)
  }

  const toggleDrawer = () => {
    setDrawer(!drawer)
    dispatch(setMenuDrawer(!drawer))
  }

  const handleMenuNavigate = (link) => {
    toggleDrawer()
    // link && navigate(link)
  }

  // Handle Main menu toggling and setting off for submenu (active , open) states
  const handleMainMenu = (index, openState) => {
    const updatedMenuList = menuList?.map((data, idx) => {
      if (data?.isCollapsible) {
        if (idx === index) {
          return {
            ...data,
            open: !openState,
            active: true,
            subMenus: data?.subMenus?.map((subMenu) => {
              return { ...subMenu, active: false, open: false }
            }),
          }
        } else {
          return { ...data, open: false, active: false }
        }
      } else {
        return { ...data, open: false, active: false }
      }
    })
    setMenuList(updatedMenuList)
  }

  // Handle Sub menu toggling -- Mapping main and sub menu array
  const handleSubMenu = (mainIndex, subIndex, mainOpenState, subOpenState) => {
    const updatedMenuList = menuList?.map((mainMenu, mainIdx) => {
      if (mainMenu?.isCollapsible) {
        if (mainIdx === mainIndex) {
          return {
            ...mainMenu,
            open: true,
            active: true,
            subMenu: mainMenu?.subMenu?.map((subMenu, subIdx) => {
              if (subMenu?.isCollapsible) {
                if (subIdx === subIndex) {
                  return { ...subMenu, open: !subOpenState, active: true }
                } else {
                  return { ...subMenu, open: false, active: false }
                }
              } else {
                return { ...subMenu, open: false, active: false }
              }
            }),
          }
        } else {
          return { ...mainMenu, open: false, active: false }
        }
      } else {
        return { ...mainMenu, open: false, active: false }
      }
    })
    setMenuList(updatedMenuList)
  }

  // Handle Main menu navigation
  const handleMainMenuNavigate = (link) => {
    link && navigate(link)
    setDrawer(false)
  }

  // Handle Main menu navigation for products
  const handleMainMenuProductNavigate = (mainCategory) => {
    !_.isEmpty(mainCategory) && navigate(`/shop/${mainCategory}`)
    setDrawer(false)
  }

  // Handle Sub Category navigation
  const handleCategoryNavigate = (mainCategory, subCategory) => {
    mainCategory &&
      subCategory &&
      navigate(`/shop/${mainCategory}/${subCategory}`)
    setDrawer(false)
  }

  // Handle sub category product style navigation
  const handleProductStyleNavigation = (
    mainCategory,
    subCategory,
    productStyle
  ) => {
    mainCategory &&
      subCategory &&
      productStyle &&
      navigate(
        `/shop?type=${mainCategory}&category=${subCategory}&productStyle=${productStyle}`
      )
    setDrawer(false)
  }

  // Get contact details api
  const getContactDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        !_.isEmpty(res?.data?.data?.results?.[0]) &&
          dispatch(
            setContactDetails({
              contactDetails: res?.data?.data?.results?.[0],
              stores: res?.data?.data?.stores,
            })
          )
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get contact details Api', err)
    }
    homeApi.getContactDetails().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getContactDetails()
  }, [getContactDetails])

  // Get search options
  const getSearchOptions = useCallback(() => {
    setSearchLoading(true);
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setSearchOptions(res?.data?.data)
      }
    }
    const onFailure = (err) => {
      console.log('Get contact details Api', err)
    }
    productApi
      .searchOptions({ search: searchInput, page: 1, limit: 10 })
      .then(onSuccess, onFailure).finally(() => setSearchLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput])
  useEffect(() => {
    !_.isEmpty(searchInput) && searchInput?.length > 2 && getSearchOptions()
  }, [getSearchOptions, searchInput])

  // Handle search handle change
  const handleSearchInput = (e, value) => {
    setSearchInput(value)
  }

  // Naviagte to search page
  const handleNavigateSearch = (searchInput) => {
    !_.isEmpty(searchInput) && navigate(`/products?search=${searchInput}`)
  }

  useEffect(() => {
    if (_.isEmpty(searchQuery)) {
      setSearchInput('')
      setSearchOptions([])
      setSearch(null)
    } else {
      setSearchInput(searchQuery)
    }
  }, [searchQuery])

  // set search option
  useEffect(() => {
    if (!_.isEmpty(searchOptions) && !_.isEmpty(searchQuery)) {
      const searchOption = searchOptions?.find(
        (data) => data?.name === searchQuery
      )
      setSearch(searchOption)
    }
  }, [searchQuery])

  return (
    <>
      {/* <section
        style={{
          boxShadow: '0px 5px 15px 5px rgb(0 0 0 / 10%)',
          position: 'relative',
        }}
      > */}
      <Caption />
      <section className={classes.headerRoot}>
        <section className={classes.container}>
          <section className={classes.headerContainer}>
            {/* Logo */}
            <section className={classes.logoContainer}>
              <div onClick={toggleDrawer} className={classes.mobileMenuIcon}>
                {drawer ? <CloseIcon /> : <MenuIcon />}
              </div>
              <img
                src="/assets/images/logo2.png"
                alt="logo"
                className={classes.logo}
                onClick={() => navigate('/')}
              />
            </section>
            {/* Web menu */}
            <section className={classes.navbar}>
              {Menu?.map((data) => (
                <section key={data?.id}>
                  {data?.isCollapsible === false ? (
                    // Menu without submenu
                    <>
                      <div className={classes.menuLabel}>
                        <Typography
                          variant="body1"
                          onClick={() => handleMainMenuNavigate(data?.link)}
                        >
                          {data?.name}
                        </Typography>
                      </div>
                    </>
                  ) : (
                    // Menu with submenu
                    <>
                      <div className={classes.dropdown}>
                        <div className={classes.menuLabel}>
                          <Typography
                            variant="body1"
                            onClick={() =>
                              handleMainMenuProductNavigate(data?.mainCategory)
                            }
                          >
                            {data?.name}
                          </Typography>
                        </div>
                        <section className={classes.dropdownWrapper}>
                          <div className={classes.dropdownContent}>
                            {data?.subMenus?.map((item) => (
                              <>
                                <section className={classes.subMenuContainer}>
                                  <div className={classes.subMenuLabel}>
                                    <Typography
                                      variant="body1"
                                      onClick={() =>
                                        handleCategoryNavigate(
                                          data?.mainCategory,
                                          item?.subCategory
                                        )
                                      }
                                    >
                                      {item?.name}
                                    </Typography>
                                  </div>
                                </section>
                              </>
                            ))}
                          </div>
                        </section>
                      </div>
                    </>
                  )}
                </section>
              ))}
            </section>
            {/* Search */}
            <section className={classes.searchWrapper}>
              {/* <TextField
                // {...params}
                name="searchInput"
                id="searchInput"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e?.target?.value)
                  handleSearchOnChange(e)
                }}
                type={'text'}
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search for jewels and more..."
                color="secondary"
                InputProps={{
                  endAdornment: (
                    <section
                      className={classes.searchIcon}
                      onClick={() => handleNavigateSearch()}
                    >
                      <SearchIcon />
                    </section>
                  ),
                }}
                onKeyDown={(e) =>
                  e.key === 'Enter' ? handleNavigateSearch() : () => {}
                }
              /> */}
              <Autocomplete
                disablePortal
                disableClearable
                size="small"
                fullWidth
                name="search"
                id="search"
                options={searchOptions}
                getOptionLabel={(option) => option.name || ''}
                loading={searchLoading}
                value={search}
                onChange={(e, value) => {
                  typeof value === 'string' && (value = searchOptions.find(eachopt => eachopt.name.toLowerCase()?.includes(value?.toLowerCase() || null)))
                  if (!(
                    typeof value === 'object' &&
                    value !== null &&
                    value?.name
                  )) {
                    setSearchPlaceHolder("No results found...!");
                    setTimeout(() => {
                      setSearchPlaceHolder(SEARCHPLACEHOLDER);
                    }, 1500);
                    return;
                  }

                    setSearch(value)
                    setSearchInput(value?.name)
                    handleNavigateSearch(value?.name)
                }}
                inputValue={searchInput}
                onInputChange={handleSearchInput}
                freeSolo
                // onKeyDown={(e) => {
                //   if (e.code === 'Enter') {
                //     handleNavigateSearch(searchInput)
                //   }
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={searchPlaceHolder}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <InputAdornment position="end">
                            {searchLoading ? <CircularProgress color="inherit" size={20} /> : <SearchIcon />}
                            
                          </InputAdornment>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </section>
            {/* Custom Request btn */}
            {/* <section className={classes.customBtn}>
              <Button
                variant="contained"
                disableElevation
                color="secondary"
                onClick={handleOpenRequestModal}
              >
                Custom Request
              </Button>
            </section> */}
          </section>
        </section>
      </section>
      {/* </section> */}

      {/* Mobile slide menu */}
      <Slide direction="up" in={drawer} mountOnEnter unmountOnExit>
        <section className={classes.drawer}>
          {menuList?.map((data, idx) => (
            <List
              key={data?.name}
              component="nav"
              aria-label="navMenu"
              onClick={() =>
                data?.isCollapsible === false && handleMenuNavigate(data?.link)
              }
            >
              {/* Main Menu Stage -- 1 */}
              <ListItemButton
                selected={data?.active === true}
                // onClick={() => {
                //   handleMainMenu(idx, data?.open)
                // }}
                className={classes.mainMenu}
              >
                <ListItemText
                  primary={
                    <section
                      className={classes.menuLabelWrapper}
                      onClick={
                        data?.isCollapsible === false
                          ? () => handleMainMenuNavigate(data?.link)
                          : () =>
                              handleMainMenuProductNavigate(data?.mainCategory)
                      }
                    >
                      <Typography variant="body1">{data?.name}</Typography>
                    </section>
                  }
                  className={
                    data?.active === true
                      ? classes.menuLabelsActive
                      : classes.menuLabelsNormal
                  }
                />
                {/* Accordion Icon */}
                {data?.isCollapsible ? (
                  data?.open ? (
                    <div
                      className={classes.activeIcon}
                      onClick={() => {
                        handleMainMenu(idx, data?.open)
                      }}
                    >
                      <ExpandLess />
                    </div>
                  ) : (
                    <div
                      className={classes.normalIcon}
                      onClick={() => {
                        handleMainMenu(idx, data?.open)
                      }}
                    >
                      <ExpandMore />
                    </div>
                  )
                ) : (
                  <></>
                )}
              </ListItemButton>
              {/* Submenu Stage -- 2 */}
              {data?.isCollapsible === true ? (
                <Collapse in={data?.open} timeout="auto" unmountOnExit>
                  {data?.subMenus?.map((item, subIdx) => (
                    <List
                      component="div"
                      disablePadding
                      key={item?.name}
                      onClick={() =>
                        item?.isCollapsible === false &&
                        handleMenuNavigate(item?.link)
                      }
                      className={classes.subMenu}
                    >
                      <ListItemButton
                        selected={item?.active === true}
                        // onClick={() => {
                        //   handleSubMenu(idx, subIdx, data?.open, item?.open)
                        // }}
                      >
                        <ListItemText
                          primary={
                            <section className={classes.subMenuLabelWrapper}>
                              <FiberManualRecordIcon />
                              <Typography variant="body1">
                                {item?.name}
                              </Typography>
                            </section>
                          }
                          onClick={() =>
                            handleCategoryNavigate(
                              data?.mainCategory,
                              item?.subCategory
                            )
                          }
                          className={
                            item?.active === true
                              ? classes.menuLabelsActive
                              : classes.menuLabelsNormal
                          }
                        />
                        {/* Accordion Icon */}
                        {/* {item?.isCollapsible ? (
                          item?.open ? (
                            <div
                              className={classes.activeIcon}
                              onClick={() => {
                                handleSubMenu(
                                  idx,
                                  subIdx,
                                  data?.open,
                                  item?.open
                                )
                              }}
                            >
                              <ExpandLess />
                            </div>
                          ) : (
                            <div
                              className={classes.normalIcon}
                              onClick={() => {
                                handleSubMenu(
                                  idx,
                                  subIdx,
                                  data?.open,
                                  item?.open
                                )
                              }}
                            >
                              <ExpandMore />
                            </div>
                          )
                        ) : (
                          <></>
                        )} */}
                      </ListItemButton>

                      {/* Nested sub menu Stage -- 3 */}
                      {/* {item?.isCollapsible === true ? (
                        <>
                          <Collapse
                            in={item?.open}
                            timeout="auto"
                            unmountOnExit
                          >
                            {item?.nestedSubMenu?.map(
                              (nestedSubMenu, nestedSubMenuIdx) => (
                                <List
                                  key={nestedSubMenu?.name}
                                  component="div"
                                  disablePadding
                                  className={classes.nestedSubMenu}
                                  onClick={() =>
                                    nestedSubMenu?.isCollapsible === false &&
                                    handleMenuNavigate(nestedSubMenu?.link)
                                  }
                                >
                                  <ListItemButton
                                    onClick={() =>
                                      handleProductStyleNavigation(
                                        data?.mainCategory,
                                        item?.subCategory,
                                        nestedSubMenu?.productStyle
                                      )
                                    }
                                  >
                                    <ListItemText
                                      primary={
                                        <section
                                          className={
                                            classes.subNestedMenuLabelWrapper
                                          }
                                        >
                                          <FiberManualRecordIcon />
                                          <Typography variant="body1">
                                            {nestedSubMenu?.name}
                                          </Typography>
                                        </section>
                                      }
                                      className={
                                        nestedSubMenu?.active === true
                                          ? classes.menuLabelsActive
                                          : classes.menuLabelsNormal
                                      }
                                    />
                                  </ListItemButton>
                                </List>
                              )
                            )}
                          </Collapse>
                        </>
                      ) : (
                        <></>
                      )} */}
                    </List>
                  ))}
                </Collapse>
              ) : (
                <></>
              )}
            </List>
          ))}
        </section>
      </Slide>

      <CustomRequestModal
        open={openRequestModal}
        handleClose={handleCloseRequestModal}
        title="Custom Request"
        btnLabel="Submit"
      />
    </>
  )
}

export default Header
